import { isNull } from 'utils/tsHelpers';
import { useCallback } from 'react';
import { ElementType, useIndex } from '../../../contexts/elementIndex';
import { useFieldArray } from '../../../contexts';

export const useRemoveClause = () => {
  const index = useIndex(ElementType.clause);
  if (isNull(index)) {
    throw new Error('Cannot delete clause: no clause index found in context');
  }
  const { remove } = useFieldArray({ name: 'conditionalContent.elseIfClauses' });
  return useCallback(() => remove(index), [remove, index]);
};
